module.exports = __webpack_public_path__ + "static/img/wc.ebf9e58.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/homepage/wc.jpg
// module id = Zbpd
// module chunks = 1